type ENV = {
  REACT_APP_INFURA_API_KEY?: string;
  REACT_APP_API_SERVER: string;
  REACT_APP_ALT_URL?: string;
  REACT_APP_TARGET_NETWORK_KLAY: number;
  REACT_APP_TARGET_NETWORK_ETH: number;
  REACT_APP_TARGET_NETWORK_BNB: number;
  REACT_APP_TARGET_NETWORK_MATIC?: number;
  REACT_APP_TARGET_NETWORK_SOL?: number;
  REACT_APP_TARGET_NETWORK_MSG?: string;
  REACT_APP_TARGET_NETWORK_TITAN?: number;
  REACT_APP_MBOX_FEE?: number;
  REACT_APP_TREASURY?: string;
  REACT_APP_ABC_WAAS_BASE_URL: string;
  REACT_APP_ABC_WAAS_CLIENT_ID?: string;
  REACT_APP_ABC_WAAS_CLIENT_SECRET?: string;
  ABC_SERVICE_ID?: string;
};

const localhost: ENV = {
  REACT_APP_API_SERVER:
    process.env.REACT_APP_API_SERVER || 'http://127.0.0.1:5001',
  REACT_APP_TARGET_NETWORK_KLAY: 1001, // baobab
  REACT_APP_TARGET_NETWORK_ETH: 3,
  REACT_APP_TARGET_NETWORK_BNB: 97,
  REACT_APP_TARGET_NETWORK_MATIC: 80001, // Mumbai
  REACT_APP_TARGET_NETWORK_TITAN: 85011,
  // REACT_APP_TARGET_NETWORK_SOL:
  REACT_APP_MBOX_FEE: 100,
  REACT_APP_TREASURY: '0xb6a0c24a7b0466821dd751cdf44e6b60731cb75e',
  REACT_APP_ABC_WAAS_BASE_URL: 'https://dev-api.waas.myabcwallet.com',
  REACT_APP_ABC_WAAS_CLIENT_ID: process.env.REACT_APP_ABC_WAAS_CLIENT_ID || '',
  REACT_APP_ABC_WAAS_CLIENT_SECRET:
    process.env.REACT_APP_ABC_WAAS_CLIENT_SECRET || '',
  ABC_SERVICE_ID: 'https://mw.myabcwallet.com',
};

const development: ENV = {
  REACT_APP_API_SERVER:
    process.env.REACT_APP_API_SERVER || 'http://127.0.0.1:5001',
  REACT_APP_TARGET_NETWORK_KLAY: 1001, // baobab
  REACT_APP_TARGET_NETWORK_ETH: 3,
  REACT_APP_TARGET_NETWORK_BNB: 97,
  REACT_APP_TARGET_NETWORK_MATIC: 80001, // Mumbai
  REACT_APP_TARGET_NETWORK_TITAN: 85011,
  // REACT_APP_TARGET_NETWORK_SOL:
  REACT_APP_MBOX_FEE: 100,
  REACT_APP_TREASURY: '0xb6a0c24a7b0466821dd751cdf44e6b60731cb75e',
  REACT_APP_ABC_WAAS_BASE_URL: 'https://dev-api.waas.myabcwallet.com',
  REACT_APP_ABC_WAAS_CLIENT_ID: process.env.REACT_APP_ABC_WAAS_CLIENT_ID || '',
  REACT_APP_ABC_WAAS_CLIENT_SECRET:
    process.env.REACT_APP_ABC_WAAS_CLIENT_SECRET || '',
  ABC_SERVICE_ID: 'https://mw.myabcwallet.com',
};

const staging: ENV = {
  REACT_APP_API_SERVER:
    process.env.REACT_APP_API_SERVER || 'http://127.0.0.1:5001',
  REACT_APP_TARGET_NETWORK_KLAY: 8217, // baobab
  REACT_APP_TARGET_NETWORK_ETH: 1,
  REACT_APP_TARGET_NETWORK_BNB: 56,
  REACT_APP_TARGET_NETWORK_MATIC: 80001, // Mumbai
  REACT_APP_TARGET_NETWORK_TITAN: 84358,
  // REACT_APP_TARGET_NETWORK_SOL:
  REACT_APP_MBOX_FEE: 100,
  REACT_APP_TREASURY: '0xb6a0c24a7b0466821dd751cdf44e6b60731cb75e',
  REACT_APP_ABC_WAAS_BASE_URL: 'https://stg-api.waas.myabcwallet.com',
  REACT_APP_ABC_WAAS_CLIENT_ID: process.env.REACT_APP_ABC_WAAS_CLIENT_ID || '',
  REACT_APP_ABC_WAAS_CLIENT_SECRET:
    process.env.REACT_APP_ABC_WAAS_CLIENT_SECRET || '',
  ABC_SERVICE_ID: 'https://mw.myabcwallet.com',
};

const production: ENV = {
  REACT_APP_API_SERVER:
    process.env.REACT_APP_API_SERVER || 'http://127.0.0.1:5001',
  REACT_APP_TARGET_NETWORK_KLAY: 8217,
  REACT_APP_TARGET_NETWORK_ETH: 1,
  REACT_APP_TARGET_NETWORK_BNB: 56,
  REACT_APP_TARGET_NETWORK_MATIC: 137, // Mainnet
  REACT_APP_TARGET_NETWORK_TITAN: 84358,
  // REACT_APP_TARGET_NETWORK_SOL:
  REACT_APP_MBOX_FEE: 100,
  REACT_APP_TREASURY: '0xb6a0c24a7b0466821dd751cdf44e6b60731cb75e',
  REACT_APP_ABC_WAAS_BASE_URL: 'https://api.waas.myabcwallet.com',
  REACT_APP_ABC_WAAS_CLIENT_ID: process.env.REACT_APP_ABC_WAAS_CLIENT_ID || '',
  REACT_APP_ABC_WAAS_CLIENT_SECRET:
    process.env.REACT_APP_ABC_WAAS_CLIENT_SECRET || '',
  ABC_SERVICE_ID: 'https://mw.myabcwallet.com',
};

const env =
  process.env.REACT_APP_PHASE === 'production'
    ? production
    : process.env.REACT_APP_PHASE === 'staging'
    ? staging
    : process.env.REACT_APP_PHASE === 'localhost'
    ? localhost
    : development;

export default env;
